import { render, staticRenderFns } from "./CustomSnoozeModal.vue?vue&type=template&id=051fe420&scoped=true&"
import script from "./CustomSnoozeModal.vue?vue&type=script&lang=js&"
export * from "./CustomSnoozeModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomSnoozeModal.vue?vue&type=style&index=0&id=051fe420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fe420",
  null
  
)

export default component.exports